export interface CommonResponseIndex {
  data: any;
  message: string;
  status: string;
}

export class CommonResponseIndex implements CommonResponseIndex {
  data: any;
  message: string;
  status: string;

  constructor() {
    this.data = null;
    this.message = "";
    this.status = "";
  }
}
